const dashboardId = {
	dashboard: {
		title: "Dashboard",
		subtitle: "Ringkasan statistik penjualan",
		sales_card: {
			title: "Total Penjualan",
			filter: {
				store: {
					all: "Semua Toko",
					selector: "Pilih Toko",
				},
				employee: {
					all: "Semua Karyawan",
					selector: "Pilih Karyawan",
				},
			},
		},
		transaction_card: {
			title: "Jumlah Transaksi",
		},
		columns: {
			day: "Hari",
			chart: "Grafik",
		},
	},
};

export default dashboardId;
